import React, { useState } from 'react';
import { doObjToFormData } from '../../helpers/helpers';
import { getAuthUserToken } from '../../helpers/authToken';
import http from '../../helpers/http';
import FormProcessingSpinner from './FormProcessingSpinner';

export default function CvActionButton({
  cv_id,
  small_btn = false,
  btn_title = "Download CV",
  is_preview = false,
}) {
  const [isProcessing, setIsProcessing] = useState(false);

  const handlePdfAction = async () => {
    try {
      setIsProcessing(true);

      const response = await http.post(
        "user/download-cv-pdf",
        doObjToFormData({ token: getAuthUserToken(), cv_id }),
        { responseType: "blob" }
      );

      const contentType = response.headers["content-type"];

      if (contentType.includes("application/json")) {
        const text = await response.data.text();
        const json = JSON.parse(text);
        if (json.status === 0) {
          alert(json.msg);
          return;
        }
      }

      if (contentType.includes("application/pdf")) {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        if (is_preview) {
          window.open(url, "_blank");
        } else {
          let filename = "cv_" + Date.now() + ".pdf";
          const contentDisposition = response.headers["content-disposition"];
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="(.+)"/);
            if (match && match[1]) filename = match[1];
          }

          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        }
      }
    } catch (error) {
      console.error("PDF Error:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  // ✅ RENDER: If preview, use your given markup exactly
  if (is_preview) {
    return (
      <button
        type="button"
        className="site_btn dim"
        onClick={handlePdfAction}
        disabled={isProcessing}
      >
        <img src="/images/cv-generator/eye.svg" alt="View" />
        <FormProcessingSpinner isFormProcessing={isProcessing} />
      </button>
    );
  }

  // ✅ Otherwise render the normal download button
  return (
    <button
      type="button"
      className={small_btn ? "site_btn sm" : "site_btn"}
      onClick={handlePdfAction}
      disabled={isProcessing}
    >
      <img src="/images/cv-generator/download.svg" alt="" />
      <span>{btn_title}</span>
      <FormProcessingSpinner isFormProcessing={isProcessing} />
    </button>
  );
}
